
import React from 'react';
import Agendamentos from './Agendamentos';
import Filter from '../../../Auxiliar/Filter';

const SelecionarJsAgendamentos = () => {
    const [search, setSearch] = React.useState(false)
    const [dateOf, setDateOf] = React.useState('')
    const [dateFor, setDateFor] = React.useState('')
    const [options, setOptions] = React.useState({
        pending: { value: true, label: 'Pendente', checked: true },
        accepted: { value: false, label: 'Aceito', checked: false },
        canceled: { value: false, label: 'Cancelado', checked: false },
        finished: { value: false, label: 'Finalizado', checked: false },
    })

    const getStatus = () => {
        return Object.values(options).find(item => item.value === true);
    }

    return (
        <div className="card">
            <div className="card-body" id="card">
                <div className="d-flex align-items-start">
                    <h4 className="mt-0 header-title" style={{ fontSize: '1.5rem', color: 'black' }}>Agendamentos</h4>
                    <Filter setDateOf={setDateOf} setDateFor={setDateFor} options={options} setOptions={setOptions} setSearch={setSearch} />
                </div>
                <div>
                    <p style={{ fontSize: '1rem', color: 'black' }}>Aqui são listados os agendamentos feitos</p>
                </div>
                <div className="row">
                    <Agendamentos dateOf={dateOf} dateFor={dateFor} allow={search} setAllow={setSearch} status={getStatus()} />
                </div>
            </div>
        </div>
    )
}

export default SelecionarJsAgendamentos
